import { createStyles, makeStyles } from '@material-ui/core/styles';
import { globalColors } from './globalColorVariables';

const useLinkFormStyles = makeStyles(() =>
  createStyles({
    linkForm: {
      backgroundColor: 'rgba(248, 248, 248, 1)',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      color: `${globalColors.primaryColor}`,
      padding: '0.7rem',
      margin: '0.6rem 0',
      width: '100%'
    },
    mobileText: {
      width: '100%',
      textAlign: 'start',
      color: `${globalColors.primaryColor}`
    },
    webText: {
      color: `${globalColors.primaryColor}`
    }
  })
);

export default useLinkFormStyles;
